import React from 'react';
import { X, AlertCircle, Mail } from 'lucide-react';

export default function DailyLimitModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Card */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 text-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
        >
          <X size={18} />
        </button>

        {/* Icon */}
        <div className="mx-auto mb-5 w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
          <AlertCircle size={32} className="text-orange-500" />
        </div>

        <h2 className="text-xl font-bold text-gray-900 mb-2">Daily AI Limit Reached</h2>
        <p className="text-gray-500 text-sm leading-relaxed mb-6">
          You have used all your AI requests for today. Your limit resets at midnight (UTC).
          <br /><br />
          If you need more access, please contact the administrator.
        </p>

        <a
          href="mailto:malikhassan32176@gmail.com?subject=AI%20Limit%20Request"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition-colors"
        >
          <Mail size={15} />
          Contact Administrator
        </a>

        <button
          onClick={onClose}
          className="block mx-auto mt-3 text-xs text-gray-400 hover:text-gray-600 transition-colors"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
